import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { LOADED, UNLOADED, isLoaded, getLoaded } from "./Context";
import useComments from "./useComments";
import { POLYMORPH, matchModel, toQuery } from "./common";

/**
 * Get the # of loaded comments for an args object.
 * @param {object} args
 * @param {boolean} load
 */
var useCommentCount = function useCommentCount(args) {
  var load = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var user = arguments.length > 2 ? arguments[2] : undefined;
  var api = arguments.length > 3 ? arguments[3] : undefined;
  var context = useComments(user, api);
  if (!POLYMORPH.every(function (v) {
    return args[v];
  })) {
    return;
  } else if (isLoaded(context, args)) {
    return context.comments.filter(matchModel(args)).length;
  } else if (load) {
    switch (getLoaded(context, _objectSpread(_objectSpread({}, args), {}, {
      count: 1
    }))) {
      case LOADED:
        return context.count[toQuery(args)];
      case UNLOADED:
        context.dispatch(_objectSpread(_objectSpread({
          type: "load"
        }, args), {}, {
          count: 1
        }));
    }
  }
};
export default useCommentCount;
//# sourceMappingURL=useCommentCount.js.map